'use strict';

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var _require = require('./response-types'),
    Value = _require.Value;

var uint8ArrayToString = require('uint8arrays/to-string');

var uint8ArrayFromString = require('uint8arrays/from-string');

module.exports = configure(function (api) {
  /**
   * @type {import('..').ImplementsMethod<'get', import('ipfs-core/src/components/dht')>}
   */
  function get(_x) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
      var options,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          message,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return api.post('dht/get', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: key instanceof Uint8Array ? uint8ArrayToString(key) : key
                }, options)),
                headers: options.headers
              });

            case 3:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 6;
              _iterator = _asyncIterator(res.ndjson());

            case 8:
              _context.next = 10;
              return _iterator.next();

            case 10:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 14;
              return _step.value;

            case 14:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 22;
                break;
              }

              message = _value;

              if (!(message.Type === Value)) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return", uint8ArrayFromString(message.Extra, 'base64pad'));

            case 19:
              _iteratorNormalCompletion = true;
              _context.next = 8;
              break;

            case 22:
              _context.next = 28;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 28:
              _context.prev = 28;
              _context.prev = 29;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 33;
                break;
              }

              _context.next = 33;
              return _iterator.return();

            case 33:
              _context.prev = 33;

              if (!_didIteratorError) {
                _context.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context.finish(33);

            case 37:
              return _context.finish(28);

            case 38:
              throw new Error('not found');

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 24, 28, 38], [29,, 33, 37]]);
    }));
    return _get.apply(this, arguments);
  }

  return get;
});